import React from 'react';

const getVisiblePages = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = [1];
  const startPage = Math.max(2, currentPage - 1);
  const endPage = Math.min(totalPages - 1, currentPage + 1);

  if (startPage > 2) {
    pages.push('start-ellipsis');
  }

  for (let page = startPage; page <= endPage; page += 1) {
    pages.push(page);
  }

  if (endPage < totalPages - 1) {
    pages.push('end-ellipsis');
  }

  pages.push(totalPages);
  return pages;
};

const CompactPagination = ({ page, total, limit, onPageChange }) => {
  const totalPages = Math.ceil((total || 0) / limit);

  if (totalPages <= 1) {
    return null;
  }

  const visiblePages = getVisiblePages(page, totalPages);

  return (
    <nav>
      <ul className="pagination pagination-sm mb-0 flex-wrap">
        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            Previous
          </button>
        </li>
        {visiblePages.map((item) => (
          item === 'start-ellipsis' || item === 'end-ellipsis' ? (
            <li key={item} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          ) : (
            <li key={item} className={`page-item ${page === item ? 'active' : ''}`}>
              <button
                type="button"
                className="page-link"
                onClick={() => onPageChange(item)}
              >
                {item}
              </button>
            </li>
          )
        ))}
        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(page + 1)}
            disabled={page === totalPages}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default CompactPagination;
